import UserUtil from './UserUtil'

class RouteUtil {
  static _globalRoutes = ['Dashboard', '404', '403', 'BKLG', 'comp_demo']

  /**
   * Define si el usuario puede acceder a una ruta especificada
   * cada aplicación debe implementarlo
   * @param userinfo
   * @param route
   * @returns {boolean}
   */
  static canEnter (userinfo, route) {
    if (RouteUtil._globalRoutes.includes(route.name)) {
      return true
    }
    // TODO SE DEBE IMPLEMENTAR SE RECOMIENDA USAR: UserUtil.can
    return true
  }

  /**
   * Retora el menu en los datos del resolve.
   * cada aplicación debe implementar este metodo
   * La respuesta del menú debe tener el siguiente formato:
   * [{ path: '/', name: 'Dashboard' }, { ... }]
   * @param userInfo
   * @param resolve
   * @param reject
   */
  static getMenu (userInfo, resolve, reject) {
    resolve(userInfo.menu)
  }
}

export default RouteUtil



// WEBPACK FOOTER //
// ./src/util/RouteUtil.js